import { render, staticRenderFns } from "./xiongMaoYinYuWx.vue?vue&type=template&id=8d44ec32&scoped=true"
import script from "./xiongMaoYinYuWx.vue?vue&type=script&lang=js"
export * from "./xiongMaoYinYuWx.vue?vue&type=script&lang=js"
import style0 from "./xiongMaoYinYuWx.vue?vue&type=style&index=0&id=8d44ec32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d44ec32",
  null
  
)

export default component.exports